import { usePreferredSearchModels } from '#pplx/frontend/apps/ask/settings/hooks/usePreferredSearchModels.js';
import { useSearchModels } from '#pplx/frontend/ask-models/hooks/useSearchModels.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback, useMemo } from 'react';
export const usePreferredSearchModelForSearchMode = () => {
    const { getPreferredSearchModel } = usePreferredSearchModels();
    const { isLoaded, getDefaultModelForMode } = useSearchModels({
        reason: 'use_preferred_search_model_for_search_mode',
    });
    const getPreferredSearchModelForSearchMode = useCallback((searchMode) => {
        return getPreferredSearchModel(searchMode) || getDefaultModelForMode(searchMode);
    }, [getPreferredSearchModel, getDefaultModelForMode]);
    return useMemo(() => ({
        getPreferredSearchModelForSearchMode,
        isLoaded,
    }), [getPreferredSearchModelForSearchMode, isLoaded]);
};
//# sourceMappingURL=usePreferredSearchModelForSearchMode.js.map